"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_PRICES = void 0;
const PRODUCT_PRICES = exports.PRODUCT_PRICES = 'product-prices';
//# sourceMappingURL=constants.js.map